// extracted by mini-css-extract-plugin
var _1 = "colors-module__acmYellow___jYwAF";
var _2 = "colors-module__carWrappingBlue___I3lEE";
var _3 = "colors-module__electricPink___tREUm";
var _4 = "colors-module__pastelBlue___yomG0";
var _5 = "colors-module__salmon___ckQXD";
var _6 = "colors-module__via-midia-black___cnvEX";
export { _1 as "acmYellow", _2 as "carWrappingBlue", _3 as "electricPink", _4 as "pastelBlue", _5 as "salmon", _6 as "via-midia-black" }
